import React from 'react';

const categoriesData = [
  {
    id: 1,
    name: '中华料理',
    count: 328,
    image: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=200&q=80'
  },
  {
    id: 2,
    name: '西式牛排',
    count: 256,
    image: 'https://images.unsplash.com/photo-1595295333158-4742f28fbd85?w=200&q=80'
  },
  {
    id: 3,
    name: '日式料理',
    count: 189,
    image: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=200&q=80'
  },
  {
    id: 4,
    name: '轻食沙拉',
    count: 145,
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=200&q=80'
  },
  {
    id: 5,
    name: '甜品蛋糕',
    count: 312,
    image: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=200&q=80'
  },
  {
    id: 6,
    name: '炖汤粥品',
    count: 98,
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=200&q=80'
  }
];

const Categories = () => {
  return (
    <section className="categories" id="categories">
      <div className="container">
        <div className="section-header">
          <h2>浏览分类</h2>
          <p>按菜系、食材或场合查找食谱</p>
        </div>
        <div className="category-grid">
          {categoriesData.map((category) => (
            <a href="#" className="category-card" key={category.id}>
              <div
                className="category-icon"
                style={{ backgroundImage: `url('${category.image}')` }}
              ></div>
              <h3>{category.name}</h3>
              <span>{category.count} 道食谱</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
